import { HashRouter, Route, Routes } from "react-router-dom";

import Home from "./pages/Home/Home";
import ToolProvider from "./domain/ToolContext/ToolProvider";
import ServiceWorkerProvider from "./domain/ServiceWorkerContext/ServiceWorkerProvider";

const Main = (): JSX.Element => (
  <ServiceWorkerProvider>
    <ToolProvider>
      <HashRouter>
        <Routes>
          <Route index element={<Home />} />
        </Routes>
      </HashRouter>
    </ToolProvider>
  </ServiceWorkerProvider>
);

export default Main;
